import { useEnterpriseSupport } from 'hooks/useEnterpriseSupport'
import React, { useMemo } from 'react'

import { EuiButtonEmpty, EuiInMemoryTable } from '@elastic/eui'
import { EuiBasicTableColumn } from '@elastic/eui/src/components/basic_table/basic_table'

import { CampaignApprovalQueueItem, CampaignType } from 'api/interfaces'
import { useGetCampaignCreativesQuery } from 'api/rtkQueryApi/platform/creativesApi'
import { AdState } from 'features/campaigns/campaign/campaignSlice'
import { buildAdColumns, toAdState } from 'features/campaigns/campaign/internet/adsGridColumns'

import { useOpenFromApprovalQueue } from './useOpenFromApprovalQueue'
import { DEFAULT_INITIAL_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from 'utils/DefaultPageSize'

interface CampaignApprovalAdsPanelProps {
  item: CampaignApprovalQueueItem
}

const campaignTypesWithDestinationUrl = [CampaignType.Internet, CampaignType.TV]

export const CampaignApprovalAdsPanel: React.FC<CampaignApprovalAdsPanelProps> = ({ item }) => {
  const isEnterpriseOrganization = useEnterpriseSupport()
  const { openAd } = useOpenFromApprovalQueue()
  const creativesQuery = useGetCampaignCreativesQuery({ accountId: item.accountId, campaignId: item.campaignId })
  const adStates = useMemo(() => (creativesQuery.data ?? []).map(toAdState), [creativesQuery.data])

  const columns: Array<EuiBasicTableColumn<AdState>> = [
    ...buildAdColumns(adStates, campaignTypesWithDestinationUrl.includes(item.campaignType), isEnterpriseOrganization),
    {
      width: '100px',
      name: '',
      render: (ad: AdState) => (
        <EuiButtonEmpty iconType='inspect' size='s' onClick={() => openAd(item, ad.id)}>
          View
        </EuiButtonEmpty>
      )
    }
  ]

  return <EuiInMemoryTable loading={creativesQuery.isLoading} items={adStates} columns={columns} pagination={{ initialPageSize: DEFAULT_INITIAL_PAGE_SIZE, pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS }} responsive={false} message='No ads on this campaign' />
}
